import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteServiceType } from '../../../../actions';

const ServiceTypeDeleteButton = ({
  dispatchDeleteServiceType,
  serviceTypeId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteServiceType({ serviceTypeId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

ServiceTypeDeleteButton.propTypes = {
  dispatchDeleteServiceType: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  serviceTypeId: PropTypes.number.isRequired,
};

ServiceTypeDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteServiceType: deleteServiceType,
};

export default connect(null, mapDispatchToProps)(ServiceTypeDeleteButton);
